import React from "react";
import { FaCalendarCheck, FaFileInvoiceDollar, FaUserClock, FaFileAlt } from "react-icons/fa";

export default function EmpDashboard() {
  const stats = [
    { title: "Total Leaves", value: 12, icon: <FaCalendarCheck />, color: "from-blue-600 to-blue-400" },
    { title: "Pending Requests", value: 3, icon: <FaUserClock />, color: "from-yellow-500 to-yellow-300" },
    { title: "Attendance %", value: "92%", icon: <FaFileInvoiceDollar />, color: "from-green-600 to-green-400" },
    { title: "Timesheets Pending", value: 5, icon: <FaFileAlt />, color: "from-purple-600 to-purple-400" },
  ];

  const quickLinks = [
    { title: "Apply Leave", icon: <FaCalendarCheck />, color: "from-blue-600 to-blue-400" },
    { title: "My Attendance", icon: <FaUserClock />, color: "from-yellow-500 to-yellow-300" },
    { title: "Download Payslip", icon: <FaFileInvoiceDollar />, color: "from-green-600 to-green-400" },
    { title: "View Holidays", icon: <FaFileAlt />, color: "from-purple-600 to-purple-400" },
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Employee Dashboard</h2>

      {/* Top Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, idx) => (
          <div
            key={idx}
            className={`flex items-center space-x-4 p-5 rounded-xl shadow-lg bg-gradient-to-r ${stat.color} text-white transform hover:scale-105 transition-transform`}
          >
            <div className="text-3xl drop-shadow-lg">{stat.icon}</div>
            <div>
              <p className="text-sm opacity-90 drop-shadow-md">{stat.title}</p>
              <h3 className="text-2xl font-bold drop-shadow-md">{stat.value}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Links Section */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {quickLinks.map((link, idx) => (
          <div
            key={idx}
            className={`flex flex-col items-center justify-center p-5 rounded-xl shadow-lg bg-gradient-to-r ${link.color} text-white cursor-pointer transform hover:scale-105 transition-transform`}
          >
            <div className="text-2xl mb-2 drop-shadow-md">{link.icon}</div>
            <span className="font-semibold text-center drop-shadow-md">{link.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
